
import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

interface UserProfileActionsProps {
  userId: string;
  userEmail?: string;
  userName: string;
  onUserDeleted: () => void;
}

export function useUserProfileActions({ userId, userEmail, userName, onUserDeleted }: UserProfileActionsProps) {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const handleSendResetEmail = async () => {
    if (!userEmail) return;
    
    try {
      const { error } = await supabase.auth.admin.generateLink({
        type: 'recovery',
        email: userEmail
      });
      
      if (error) throw error;
      
      toast.success("Password reset email sent", {
        description: `A password reset email has been sent to ${userEmail}`
      });
    } catch (error: any) {
      toast.error("Error", {
        description: error.message || "Failed to send password reset email"
      });
    }
  };

  const handleEraseUserData = async () => {
    if (!userId) return;
    
    try {
      const { error } = await supabase
        .from('profiles')
        .delete()
        .eq('id', userId);

      if (error) throw error;

      toast.success("User data erased", {
        description: "All user data has been successfully erased"
      });
    } catch (error: any) {
      toast.error("Error", {
        description: error.message || "Failed to erase user data"
      });
    }
  };

  const handleDeleteUser = () => {
    setDeleteDialogOpen(true);
  };

  return {
    handleSendResetEmail,
    handleEraseUserData,
    handleDeleteUser,
    deleteDialogOpen,
    setDeleteDialogOpen,
    userName,
  };
}
